export default {
    /** @type {services} */
    SERVICES: 'services',

    /** @type {service-profiles} */
    SERVICE_PROFILES: 'service-profiles',

    /**@type {'directrouting'} */
    DIRECT_ROUTING: 'directrouting',
    /**@type {'sbcaas'} */
    SBCAAS: 'sbcaas',
    /**@type {'operatorconnect'} */
    OPERATOR_CONNECT: 'operatorconnect',
    /**@type {'occ'} */
    OPERATOR_CONNECT_CONFERENCE: 'occ',
    /**@type {'tpm'} */
    TEAM_PHONE_MOBILE: 'tpm',
    /**@type {'acsservice'} */
    AZURE_CONNECT_SERVICE: 'acsservice',
    /**@type {'appauth'} */
    APP_AUTH: 'appauth',
    /**@type {'vendordefined'} */
    VENDOR_DEFINED: 'vendordefined',
    /**@type {'zoomauth'} */
    ZOOM_AUTH: 'zoomauth',
    /**@type {'zoom'} */
    ZOOM: 'zoom',
    /**@type {'eightbyeightauth'} */
    EIGHTBYEIGHT_AUTH: 'eightbyeightauth',
    /**@type {'eightbyeight'} */
    EIGHTBYEIGHT: 'eightbyeight',
    /**@type {'ringcentralauth'} */
    RINGCENTRAL_AUTH: 'ringcentralauth',
    /**@type {'ringcentral'} */
    RINGCENTRAL: 'ringcentral',
    /**@type {'dialpadauth'} */
    DIALPAD_AUTH: 'dialpadauth',
    /**@type {'dialpad'} */
    DIALPAD: 'dialpad',
    /**@type {'gcchigh'} */
    GCCHIGH: 'gcchigh',
    /**@type {'webex'} */
    WEBEX: 'webex',
    /**@type {'webexauth'} */
    WEBEX_AUTH: 'webexauth',
    /**@type {'directroutinggcchigh'} */
    GCC_HIGH: 'directroutinggcchigh',
    /**@type {'srt'} */
    SRT: 'srt',

    /** @type {'/services/sbcaaas'} */
    SERVICES_SBCAAAS: '/services/sbcaaas',

    /** @type {'/services/operatorconnect'} */
    SERVICES_OPERATOR_CONNECT: '/services/operatorconnect',

    /** @type {'services/occ'} */
    SERVICES_OCC: '/services/occ',

    /** @type {'services/directrouting'} */
    SERVICES_DIRECT_ROUTING: '/services/directrouting',

    /** @type {'services/directroutinggcchigh'} */
    SERVICES_DIRECT_ROUTING_GCCHIGH: '/services/directroutinggcchigh',

    /** @type {'services/acsservice'} */
    SERVICES_AZURE_CONNECT_SERVICE: '/services/acsservice',

    /** @type {':id/activation'} */
    SERVICES_TPM_TRIAL: ':id/activation/*',

    /** @type {'activation/associated-accounts'} */
    SERVICES_TPM_ASSOCIATED_ACC: 'activation/associated-accounts',

    /** @type {'/service-profiles/occ'} */
    SERVICE_PROFILES_OCC: '/service-profiles/occ',

    /** @type {'/services/appauth'} */
    SERVICES_APP_AUTH: '/services/appauth',

    /** @type {':id/users'} */
    SERVICES_VD_USERS: ':id/users',
    /** @type {':id/numbers'} */
    SERVICES_VD_NUMBERS: ':id/numbers',

    /** @type {'/services/zoom'} */
    SERVICES_ZOOM: '/services/zoom',

    /** @type {'/services/zoomauth'} */
    SERVICES_ZOOM_AUTH: '/services/zoomauth',

    /** @type {'/services/eightbyeight'} */
    SERVICES_8X8_AUTH: '/services/eightbyeight',

    /** @type {'/services/eightbyeightauth'} */
    SERVICES_EIGHTBYEIGHT_AUTH: '/services/eightbyeightauth',

    /** @type {'/services/ringcentral'} */
    SERVICES_RINGCENTRAL: '/services/ringcentral',

    /** @type {'/services/ringcentralauth'} */
    SERVICES_RINGCENTRAL_AUTH: '/services/ringcentralauth',

    /** @type {'/services/dialpad'} */
    SERVICES_DIALPAD: '/services/dialpad',

    /** @type {'/services/dialpadauth'} */
    SERVICES_DIALPAD_AUTH: '/services/dialpadauth',

    /** @type {'services/gcchigh'} */
    SERVICES_GCCHIGH: '/services/gcchigh',

    /** @type {'/services/webex'} */
    SERVICES_WEBEX: '/services/webex',

    /** @type {'/services/webexauth'} */
    SERVICES_WEBEX_AUTH: '/services/webexauth',
};
